import { PARTNER_ID_KEY } from 'screens/VideoCalls/utils/constants'
import { isDexcomVideoCallPartner } from 'screens/VideoCalls/utils/dexcomPartner'
import { useLocalStorage } from 'utils/localStorage'

export const useIsDexcomFlow = () => {
  const [partner] = useLocalStorage(PARTNER_ID_KEY)

  return isDexcomVideoCallPartner(partner)
}
